import { saveAs } from 'file-saver'
import apiClient from '../../../utils/clients/axios'

// The backend streams the .xlsx file directly; save it in the browser.
const downloadReport = async (path, { fromDate, toDate }) => {
    try {
        const response = await apiClient.get(
            `${path}/report/?from_date=${fromDate}&to_date=${toDate}`,
            { responseType: 'blob' }
        )
        const disposition = response.headers['content-disposition'] || ''
        const match = disposition.match(/filename="?([^";]+)"?/)
        const fileName = match ? match[1] : `${path.replace('/', '')}_report_${fromDate}_${toDate}.xlsx`
        saveAs(response.data, fileName)
    } catch (err) {
        // Error bodies arrive as a Blob too; turn them back into JSON/text
        const data = err?.response?.data
        if (data instanceof Blob) {
            const text = await data.text()
            try {
                err.response.data = JSON.parse(text)
            } catch (e) {
                err.response.data = text
            }
        }
        throw err
    }
}

export const getMilkReport = (dates) => downloadReport('/milk', dates)

export const getGuestReport = (dates) => downloadReport('/guests', dates)

export const getVechileReport = (dates) => downloadReport('/vehicle', dates)

export const getMaterialInwardReport = (dates) => downloadReport('/materialinward', dates)

export const getMaterialOutwardReport = (dates) => downloadReport('/materialoutward', dates)

export const getMaterialReturnableReport = (dates) => downloadReport('/returnablematerials', dates)

export const getKeysReport = (dates) => downloadReport('/keys', dates)
